import LowFareCalendarOIV2Container from '../../../../components/containers/LowFareCalendarOIV2Container';
import preloadCustomProps from '../../../utils/preloads/preloadLowFareCalendarProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'low-fare-calendar-outbound-inbound-v2',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: LowFareCalendarOIV2Container
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
